// ======================= AUTHENTICATION =======================
export const REGISTER_USER_REQUEST = 'REGISTER_USER_REQUEST';
export const REGISTER_USER_SUCCESS = 'REGISTER_USER_SUCCESS';
export const REGISTER_USER_FAIL = 'REGISTER_USER_FAIL';

export const LOGIN_USER_REQUEST = 'LOGIN_USER_REQUEST';
export const LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS';
export const LOGIN_USER_FAIL = 'LOGIN_USER_FAIL';

export const LOGOUT_USER_REQUEST = 'LOGOUT_USER_REQUEST';
export const LOGOUT_USER_SUCCESS = 'LOGOUT_USER_SUCCESS';
export const LOGOUT_USER_FAIL = 'LOGOUT_USER_FAIL';

// ======================= PASSWORD =======================
export const FORGOT_PASSWORD_REQUEST = 'FORGOT_PASSWORD_REQUEST';
export const FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS';
export const FORGOT_PASSWORD_FAIL = 'FORGOT_PASSWORD_FAIL';

export const RESET_PASSWORD_REQUEST = 'RESET_PASSWORD_REQUEST';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_FAIL = 'RESET_PASSWORD_FAIL';

export const UPDATE_PASSWORD_REQUEST = 'UPDATE_PASSWORD_REQUEST';
export const UPDATE_PASSWORD_SUCCESS = 'UPDATE_PASSWORD_SUCCESS';
export const UPDATE_PASSWORD_FAIL = 'UPDATE_PASSWORD_FAIL';

// ======================= USER PROFILE =======================
export const LOAD_USER_REQUEST = 'LOAD_USER_REQUEST';
export const LOAD_USER_SUCCESS = 'LOAD_USER_SUCCESS';
export const LOAD_USER_FAIL = 'LOAD_USER_FAIL';

export const UPDATE_PROFILE_REQUEST = 'UPDATE_PROFILE_REQUEST';
export const UPDATE_PROFILE_SUCCESS = 'UPDATE_PROFILE_SUCCESS';
export const UPDATE_PROFILE_FAIL = 'UPDATE_PROFILE_FAIL';

export const GET_USER_ACTIVITY_REQUEST = 'GET_USER_ACTIVITY_REQUEST';
export const GET_USER_ACTIVITY_SUCCESS = 'GET_USER_ACTIVITY_SUCCESS';
export const GET_USER_ACTIVITY_FAIL = 'GET_USER_ACTIVITY_FAIL';

// ======================= ADMIN: USER MANAGEMENT =======================
export const ALL_USERS_REQUEST = 'ALL_USERS_REQUEST';
export const ALL_USERS_SUCCESS = 'ALL_USERS_SUCCESS';
export const ALL_USERS_FAIL = 'ALL_USERS_FAIL';

export const USERS_BY_FRANCHISE_REQUEST = 'USERS_BY_FRANCHISE_REQUEST';
export const USERS_BY_FRANCHISE_SUCCESS = 'USERS_BY_FRANCHISE_SUCCESS';
export const USERS_BY_FRANCHISE_FAIL = 'USERS_BY_FRANCHISE_FAIL';

export const CREATE_USER_REQUEST = 'CREATE_USER_REQUEST';
export const CREATE_USER_SUCCESS = 'CREATE_USER_SUCCESS';
export const CREATE_USER_FAIL = 'CREATE_USER_FAIL';

export const EDIT_USER_REQUEST = 'EDIT_USER_REQUEST';
export const EDIT_USER_SUCCESS = 'EDIT_USER_SUCCESS';
export const EDIT_USER_FAIL = 'EDIT_USER_FAIL';

export const DELETE_USER_REQUEST = 'DELETE_USER_REQUEST';
export const DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS';
export const DELETE_USER_FAIL = 'DELETE_USER_FAIL';

export const CHANGE_USER_ROLE_REQUEST = 'CHANGE_USER_ROLE_REQUEST';
export const CHANGE_USER_ROLE_SUCCESS = 'CHANGE_USER_ROLE_SUCCESS';
export const CHANGE_USER_ROLE_FAIL = 'CHANGE_USER_ROLE_FAIL';

export const TOGGLE_USER_STATUS_REQUEST = 'TOGGLE_USER_STATUS_REQUEST';
export const TOGGLE_USER_STATUS_SUCCESS = 'TOGGLE_USER_STATUS_SUCCESS';
export const TOGGLE_USER_STATUS_FAIL = 'TOGGLE_USER_STATUS_FAIL';

// ======================= FRANCHISE MANAGEMENT =======================
export const CREATE_FRANCHISE_REQUEST = 'CREATE_FRANCHISE_REQUEST';
export const CREATE_FRANCHISE_SUCCESS = 'CREATE_FRANCHISE_SUCCESS';
export const CREATE_FRANCHISE_FAIL = 'CREATE_FRANCHISE_FAIL';

export const GET_ALL_FRANCHISES_REQUEST = 'GET_ALL_FRANCHISES_REQUEST';
export const GET_ALL_FRANCHISES_SUCCESS = 'GET_ALL_FRANCHISES_SUCCESS';
export const GET_ALL_FRANCHISES_FAIL = 'GET_ALL_FRANCHISES_FAIL';

export const SELECT_FRANCHISE_REQUEST = 'SELECT_FRANCHISE_REQUEST';
export const SELECT_FRANCHISE_SUCCESS = 'SELECT_FRANCHISE_SUCCESS';
export const SELECT_FRANCHISE_FAIL = 'SELECT_FRANCHISE_FAIL';

export const SET_FRANCHISE_CONSOLE_REQUEST = 'SET_FRANCHISE_CONSOLE_REQUEST';
export const SET_FRANCHISE_CONSOLE_SUCCESS = 'SET_FRANCHISE_CONSOLE_SUCCESS';
export const SET_FRANCHISE_CONSOLE_FAIL = 'SET_FRANCHISE_CONSOLE_FAIL';

export const GET_ACCESSIBLE_FRANCHISES_REQUEST = 'GET_ACCESSIBLE_FRANCHISES_REQUEST';
export const GET_ACCESSIBLE_FRANCHISES_SUCCESS = 'GET_ACCESSIBLE_FRANCHISES_SUCCESS';
export const GET_ACCESSIBLE_FRANCHISES_FAIL = 'GET_ACCESSIBLE_FRANCHISES_FAIL';

// ======================= FRANCHISE STOCK/SALES =======================
export const GET_FRANCHISE_STOCK_REQUEST = 'GET_FRANCHISE_STOCK_REQUEST';
export const GET_FRANCHISE_STOCK_SUCCESS = 'GET_FRANCHISE_STOCK_SUCCESS';
export const GET_FRANCHISE_STOCK_FAIL = 'GET_FRANCHISE_STOCK_FAIL';

export const GET_FRANCHISE_SALES_REQUEST = 'GET_FRANCHISE_SALES_REQUEST';
export const GET_FRANCHISE_SALES_SUCCESS = 'GET_FRANCHISE_SALES_SUCCESS';
export const GET_FRANCHISE_SALES_FAIL = 'GET_FRANCHISE_SALES_FAIL';

// ======================= CLEAR ERRORS =======================
export const CLEAR_ERRORS = 'CLEAR_ERRORS';

// ** New: Edit Franchise **
export const EDIT_FRANCHISE_REQUEST      = 'EDIT_FRANCHISE_REQUEST';
export const EDIT_FRANCHISE_SUCCESS      = 'EDIT_FRANCHISE_SUCCESS';
export const EDIT_FRANCHISE_FAIL         = 'EDIT_FRANCHISE_FAIL';

// ** New: Delete Franchise **
export const DELETE_FRANCHISE_REQUEST    = 'DELETE_FRANCHISE_REQUEST';
export const DELETE_FRANCHISE_SUCCESS    = 'DELETE_FRANCHISE_SUCCESS';
export const DELETE_FRANCHISE_FAIL       = 'DELETE_FRANCHISE_FAIL';